import {Directive, ViewContainerRef} from '@angular/core';

@Directive({standalone: true, selector: '[pubResultList]'})
export class ResultListDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}
